import { IDataTypeSerializerFactory, IOperationSerializerFactory, IParameterSerializerFactory, IPropertySerializerFactory, DefaultOperationSerializerFactory, DefaultParameterSerializerFactory, DefaultPropertySerializerFactory, ICommonStructureSerializerFactory, DefaultStructureSerializerFactory } from '@ecp-caf/common-structure';
import { IGspDtoSerializeContext } from '../extension/i-gsp-dto-serialize-context';
import { GspDtoDataTypeSerializerFactory } from './factory/dto-data-type-serializer-factory';


export class GspDtoSerializeContext implements IGspDtoSerializeContext {

    private dataTypeFactory: IDataTypeSerializerFactory;
    private operationFactory: IOperationSerializerFactory;
    private parameterFactory: IParameterSerializerFactory;
    private propertyFactory: IPropertySerializerFactory;
    private structureFactory:ICommonStructureSerializerFactory;

    getDataTypeSerializerFactory(): IDataTypeSerializerFactory {
        if (!this.dataTypeFactory) {
            this.dataTypeFactory = new GspDtoDataTypeSerializerFactory();
        }
        return this.dataTypeFactory;
    }

    getOperationSerializerFactory(): IOperationSerializerFactory {
        if (!this.operationFactory) {
            this.operationFactory = new DefaultOperationSerializerFactory();
        }
        return this.operationFactory;
    }

    getParameterSerializerFactory(): IParameterSerializerFactory {
        if (!this.parameterFactory) {
            this.parameterFactory = new DefaultParameterSerializerFactory();
        }
        return this.parameterFactory;
    }

    getPropertySerializerFactory(): IPropertySerializerFactory {
        if (!this.propertyFactory) {
            this.propertyFactory = new DefaultPropertySerializerFactory();
        }
        return this.propertyFactory;
    }

    getStructureSerializerFactory(): ICommonStructureSerializerFactory {
        if(!this.structureFactory){
            this.structureFactory=new DefaultStructureSerializerFactory();
        }
        return this.structureFactory;
    }
}